import { jsx as _jsx } from "react/jsx-runtime";
/**
 * JiraIcon - official Jira brand logo component.
 *
 * Renders the Jira three-chevron mark in the official brand blue (#2684FF).
 *
 * Usage rules (context/iconography.md):
 * - Do not apply CSS color (fill uses the official brand color)
 * - Do not recolor or modify the path
 * - Use `size` prop for scaling - do not change viewBox
 * - Only use for Jira identity in the integration catalog / resource display
 */
export function JiraIcon({ size = 20, className }) {
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", "aria-hidden": "true", className: className, children: _jsx("path", { d: "M11.571 11.513H0a5.218 5.218 0 0 0 5.232 5.215h2.13v2.057A5.215 5.215 0 0 0 12.575 24V12.518a1.005 1.005 0 0 0-1.005-1.005zm5.723-5.756H5.736a5.215 5.215 0 0 0 5.215 5.214h2.129v2.058a5.218 5.218 0 0 0 5.215 5.214V6.758a1.001 1.001 0 0 0-1-1zM23.013 0H11.455a5.215 5.215 0 0 0 5.215 5.215h2.129v2.057A5.215 5.215 0 0 0 24 12.483V1.005A1.001 1.001 0 0 0 23.013 0z", fill: "#2684FF" }) }));
}
//# sourceMappingURL=JiraIcon.js.map